export default "__VITE_ASSET__DCv4Grd0__"